import React, { useEffect, useState } from "react";
import orcid from "../../components/assets/orcidIcon.png";
import "./PublicationDetailsCard.scss";
import SanitizeHtml from "../SanitizeHtml/SanitizeHtml";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import "./PublicationDetailsCard.scss";
import AxiosService from "../../utils/AxiosService";
import CitationModal from "../CitationModal/CitationModal";
import GrantsModal from "../GrantsModal/GrantsModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ReportErrorModal from "../ReportErrorModal/ReportErrorModal";

const defaultAuthorsListLength = 3;

const PublicationDetailsCard = ({ cardData }) => {
  const [data, setData] = useState(null);
  const [showFullAuthors, setShowFullAuthors] = useState(false);
  const [showCitationModal, setShowCitationModal] = useState(false);
  const [showGrantsModal, setShowGrantsModal] = useState(false);
  const [showReportErrorModal, setShowReportErrorModal] = useState(false);

  const [citationData, setCitationData] = useState(null);

  const axiosService = new AxiosService();

  const handleCitationClick = () => {
    setShowCitationModal(true);
    getCitation(data.doi);
  };

  const handleGrantsClick = () => {
    setShowGrantsModal(true);
  };
  const handleReportErrorClick = () => {
    setShowReportErrorModal(true);
  };

  function getCitation(doi) {
    axiosService
      .getCitation({ doi })
      .then((res) => {
        setCitationData(res.data);
      })
      .catch((err) => {
        console.error("Error fetching suggestions:", err);
      });
  }

  useEffect(() => {
    if (!cardData) return;
    setData((prev) => ({
      ...cardData,
      authorsList: [
        ...cardData.authorsList.filter((item) => item.orcid),
        ...cardData.authorsList.filter((item) => !item.orcid),
      ],
    }));
  }, [cardData]);

  return (
    data && (
      <>
        <CitationModal
          show={showCitationModal}
          onClose={() => setShowCitationModal(false)}
          citationData={citationData}
        />
        <GrantsModal
          show={showGrantsModal}
          onClose={() => setShowGrantsModal(false)}
          grantsData={cardData.grantId}
          doi={cardData.doi}
        />

        <ReportErrorModal
          show={showReportErrorModal}
          onClose={() => setShowReportErrorModal(false)}
          doi={cardData.doi}
        />

        <div className="container-fluid my-1 px-0 publication-details-card">
          <div className="card shadow-sm">
            <div className="card-body text-start text-secondary">
              {/* Article Title */}
              <div className="mb-4">
                <small className="text-uppercase text-muted fw-semibold">
                  Article Title
                </small>
                <h5 className="fw-semibold mt-1">
                  {<SanitizeHtml filterText={data.title} /> || ""}
                </h5>
              </div>

              {/* Details Grid */}
              <div className="row gy-4">
                {/* Publisher */}
                <div className="col-lg-3 col-md-4">
                  <small className="text-uppercase text-muted fw-semibold">
                    Publisher
                  </small>
                  <div>{data.publisher}</div>
                </div>
                {/* Type */}
                <div className="col-lg-3 col-md-4">
                  <small className="text-uppercase text-muted fw-semibold">
                    Type
                  </small>
                  <div>{data.type}</div>
                </div>
                {/* Print Date */}
                <div className="col-lg-3 col-md-4">
                  <small className="text-uppercase text-muted fw-semibold">
                    Print Publication Date
                  </small>
                  <div>{data.printPublicationDate}</div>
                </div>
                {/* DOI */}
                <div className="col-lg-3 col-md-4">
                  <small className="text-uppercase text-muted fw-semibold">
                    DOI
                  </small>
                  <div className="">
                    <a
                      href={data.doi}
                      target="_blank"
                      rel="noreferrer"
                      className=" d-inline-flex text-break gap-2"
                    >
                      <FontAwesomeIcon
                        icon={faUpRightFromSquare}
                        className="pt-1"
                      />
                      {data.doi}
                    </a>
                  </div>
                </div>
                {/* Authors */}
                <div className="col-lg-3 col-md-4">
                  <small className="text-uppercase text-muted fw-semibold">
                    Authors
                  </small>
                  <br />
                  {data.authorsList
                    .slice(
                      0,
                      showFullAuthors
                        ? data.authorsList.length
                        : defaultAuthorsListLength,
                    )
                    .map((item, index) => (
                      <div
                        className={`mt-1 ${item.orcid ? "" : "d-inline"}`}
                        key={index}
                      >
                        {/* <div className="fw-semibold">{data.primaryAuthor}</div> */}
                        <div
                          className={`fw-semibold  ${
                            item.orcid ? "text-dark" : "d-inline"
                          }`}
                        >
                          {item.name}
                          {item.orcid
                            ? ""
                            : index === data.authorsList.length - 1
                              ? ""
                              : ", "}
                        </div>

                        {item.orcid && (
                          <div className="d-flex align-items-center">
                            <a
                              href={item.orcid}
                              target="_blank"
                              rel="noreferrer"
                              className=" "
                            >
                              <img
                                role="button"
                                src={orcid}
                                alt="orcid"
                                className="me-1"
                              />
                              {item.orcid}
                            </a>
                          </div>
                        )}
                        {/* <div className="mt-0 text-muted">{item.authors}</div> */}
                      </div>
                    ))}
                  {data.authorsList.length > defaultAuthorsListLength && (
                    <span
                      className="cursor-pointer  text-decoration-underline"
                      onClick={() => setShowFullAuthors(!showFullAuthors)}
                    >
                      {" "}
                      {showFullAuthors ? " show less" : "+more"}
                    </span>
                  )}
                </div>
                {/* Journal */}
                <div className="col-lg-3 col-md-4">
                  <small className="text-uppercase text-muted fw-semibold">
                    Journal Name
                  </small>
                  <div>
                    {data.journalName}
                    {(data.volume || data.issue) && (
                      <div className="text-muted">
                        ({data.volume && `Volume: ${data.volume}`}
                        {data.volume && data.issue && ", "}
                        {data.issue && `Issue: ${data.issue}`})
                      </div>
                    )}
                  </div>
                </div>
                {/* Online Date */}
                {
                  <div
                    className={`col-md-4 ${data.publiclyAccessibleDate && "col-lg-3 "}`}
                  >
                    <small className="text-uppercase text-muted fw-semibold">
                      Online Publication Date
                    </small>
                    <div>{data.onlinePublicationDate}</div>
                  </div>
                }
                {cardData?.publiclyAccessibleDate && (
                  <div className="col-lg-3 col-md-4">
                    <small className="text-uppercase text-muted fw-semibold">
                      {" "}
                      &nbsp;
                    </small>
                    <div>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="tooltip-top" className="tooltip-justify">
                            CHORUS has verified that a version of this article
                            has been made publicly available on the publishers’
                            site.
                          </Tooltip>
                        }
                      >
                        <span style={{ cursor: "pointer" }}>
                          Publicly Accessible
                        </span>
                      </OverlayTrigger>
                    </div>
                  </div>
                )}
                {/* Funders */}
                <div className="col-lg-3 col-md-4">
                  <small className="text-uppercase text-muted fw-semibold">
                    Funders
                  </small>
                  <div>{data.funders}</div>
                </div>
                {/* Cite */}
                <div className="col-lg-3 col-md-4">
                  <small className="text-uppercase text-muted fw-semibold">
                    {" "}
                    &nbsp;
                  </small>
                  <div>
                    <span onClick={handleCitationClick} className="cite-link">
                      Cite
                    </span>
                  </div>
                </div>
                {/* Grants */}
                <div className="col-lg-3 col-md-4">
                  <small className="text-uppercase text-muted fw-semibold">
                    {" "}
                    &nbsp;
                  </small>
                  {cardData?.grantId && (
                    <div>
                      <span onClick={handleGrantsClick} className="grant-link">
                        Grants
                      </span>
                    </div>
                  )}
                </div>
                {/* Report Error */}
                <div className="col-lg-3 col-md-4">
                  <small className="text-uppercase text-muted fw-semibold">
                    {" "}
                    &nbsp;
                  </small>
                  <div>
                    <span
                      onClick={handleReportErrorClick}
                      className="report-error-link"
                    >
                      Report Error
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
};

export default PublicationDetailsCard;
